<template>
  <v-card
    class="mx-auto"
    color="red darken-4"
    min-width="250"
    min-height="600"
    max-height="700"
    max-width="400"
    dark
  >
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline" @click="initData"
          >Trend Top
        </v-list-item-title>
        <v-list-item-subtitle>{{ trend_Top }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text v-show="showAfterLoad">
      <div class="text-center ma-12" align="center">
        <v-progress-circular
          class=""
          :indeterminate="true"
          :rotate="0"
          :size="128"
          :value="load_value"
          :width="8"
          color="light-blue"
          >{{ load_value }}</v-progress-circular
        >
      </div>
    </v-card-text>
    <v-container v-show="!showAfterLoad">
      <v-card-text>
        <v-row align="center">
          <v-col class="display-1 text-right" cols="12">
            {{ total_simulado }} Simulações
            <!-- <v-img
            src="https://cdn.vuetifyjs.com/images/cards/sun.png"
            alt="Sunny image"
            width="92"
          ></v-img> -->
          </v-col>
        </v-row>
      </v-card-text>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-cellphone-text</v-icon>
        </v-list-item-icon>
        <v-list-item-subtitle
          >{{ total_financiamento }} Financiamento</v-list-item-subtitle
        >
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-cellphone</v-icon>
        </v-list-item-icon>
        <v-list-item-subtitle
          >{{ total_consorcio }} Consórcio</v-list-item-subtitle
        >
      </v-list-item>

      <v-list class="transparent" style="max-height: 50px">
        <v-list-item>
          <v-list-item-subtitle class="text-left">Item</v-list-item-subtitle>

          <v-list-item-subtitle class="text-center">
            Financiamento
          </v-list-item-subtitle>

          <v-list-item-subtitle class="text-center">
            Consórcio
          </v-list-item-subtitle>

          <v-list-item-subtitle class="text-center">
            Total
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
      <v-divider class="mx-4"></v-divider>

      <v-list class="transparent overflow-y-auto" style="max-height: 250px">
        <v-list-item v-for="item in forecast" :key="item.desc">
          <v-list-item-title class="caption">{{
            item.veiculos
          }}</v-list-item-title>

          <v-list-item-subtitle class="text-right">
            {{ item.total_financiamento }}
          </v-list-item-subtitle>

          <v-list-item-subtitle class="text-right">
            {{ item.total_consorcio }}
          </v-list-item-subtitle>

          <v-list-item-subtitle class="text-right">
            {{ item.total }}
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-container>
  </v-card>
</template>

<script>
import firebase from "@/plugins/firebase";
import { mapActions, mapGetters } from "vuex";
export default {
  created() {
    this.$on("updateLineChart", data => {});
  },
  data() {
    return {
      labels: ["+ Sale", "+ Money", "- Sale", "- Money"],
      load_value: "Load",
      showAfterLoad: true,
      trend_Top: "Veículos Simulado",
      time: 0,
      total_consorcio: 0,
      total_financiamento: 0,
      total_simulado: 0,
      forecast: [],
      date_init: "",
      date_end: "",
      isCompany: false,
      company: []
    };
  },
  methods: {
    ...mapActions("appAnalytics", ["setTrend"]),
    async _getTrendTop() {
      return new Promise(async resolve => {
        const app_analytics = firebase
          .functions()
          .httpsCallable("app_analytics/trendTop");
        app_analytics({
          date_init: this.date_init,
          date_end: this.date_end,
          isCompany: this.isCompany,
          company: this.company
        })
          .then(result => {
            return resolve(result.data);
          })
          .catch(erro => {
            return resolve(false);
            console.log(erro);
          });
      });
    },
    async initData() {
      const callDate = this.getFilter;
      this.date_init = callDate.date[0];
      this.date_end = callDate.date[1];
      this.company = callDate.empresas;
      this.isCompany = callDate.withCompany;
      this.showAfterLoad = true;
      this._getTrendTop().then(v => {
        this.total_consorcio = 0;
        this.total_financiamento = 0;
        this.total_simulado = 0;
        this.forecast = [];
        v.forEach((a, b) => {
          setTimeout(() => {
            this.total_consorcio += Number(a.total_consorcio);
            this.total_financiamento += Number(a.total_financiamento);
            this.total_simulado +=
              Number(a.total_financiamento) + Number(a.total_consorcio);
            this.forecast.push(a);
          }, 125 * b);
        });
        this.showAfterLoad = false;
      });
    }
  },
  computed: {
    ...mapGetters("appAnalytics", ["getFilter"])
  },
  watch: {
    getFilter(m, v) {
      this.initData();
    }
  },
  mounted() {
    this.initData();
  }
};
</script>
